export const GET_ENV = 'GET_ENV';
export const SET_ENV = 'SET_ENV';

const defaultState = {
    'env': 'pc'
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case GET_ENV:
            return Object.assign({}, state);
        case SET_ENV:
            return Object.assign({}, state, {
                'env': action.value
            });
        default:
            return state;
    }
};

const setEnv = (env) => ({
    type: SET_ENV,
    value: env
});

export default {
    reducer,
    setEnv
};